import { useEventCallback } from '@cian/react-utils';
import { useState, useCallback, useMemo, FC, PropsWithChildren } from 'react';
import { useOffer } from '../../hooks';
import { NotAvailablePopupContext, useChatContext } from '../../context';

export const NotAvailablePopupContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const { openChat } = useChatContext();
  const { id } = useOffer();

  const [offerWithPopup, setOfferWithPopup] = useState<number | null>(null);

  const closePopup = useEventCallback(() => {
    setOfferWithPopup(null);
  });

  const openPopup = useCallback(() => {
    setOfferWithPopup(id);

    openChat();
  }, [id, openChat]);

  const context = useMemo(
    () => ({
      offerWithPopup,
      openNotAvailablePopup: openPopup,
      closeNotAvailablePopup: closePopup,
    }),
    [offerWithPopup, openPopup, closePopup],
  );

  return <NotAvailablePopupContext.Provider value={context}>{children}</NotAvailablePopupContext.Provider>;
};
